var map = {
	"./views/order/box": [
		40570,
		570
	],
	"./views/plugin/box": [
		80879,
		1771,
		879,
		7357
	],
	"./views/storehouse/box": [
		75160,
		5160
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function() { return Object.keys(map); };
webpackAsyncContext.id = 9208;
module.exports = webpackAsyncContext;